import React from 'react';
import { Title } from 'src/components';
import RouterLink from 'src/components/links';

export interface IProps {
    title?: string;
    renderAs?: string;
    className?: string;
    classNameLink?: string;
    link?: string;
    children?: any;
}

export function TitleWrap({
    className,
    classNameLink,
    renderAs = 'h3',
    title,
    link,
    children,
}: IProps) {
    if (!title) {
        return null;
    }

    if (link) {
        return (
            <Title renderAs={renderAs} className={className}>
                <RouterLink to={link} className={classNameLink}>
                    <span>{title}</span>
                </RouterLink>
                {children}
            </Title>
        );
    }

    return (
        <Title renderAs={renderAs} className={className}>
            <span>{title}</span>
            {children}
        </Title>
    );
}

export default React.memo(TitleWrap);
